import { Input } from "@atoms/input";
import React, { FC, useMemo } from "react";
import { BookingFormFieldsProps } from "./interfaces";
import { useTranslation } from "next-i18next";
import styled from "styled-components";
import { BookingDatePicker } from "./booking-date-picker";

export const BookingFormFields: FC<BookingFormFieldsProps> = ({
  disabled,
  register,
  errors,
  control,
  onGetCalendar,
}) => {
  const { t } = useTranslation();

  const guestsOptions = useMemo(
    () => [
      { value: "1", label: "1 " + t("guest", { count: 1 }) },
      { value: "2", label: "2 " + t("guest", { count: 2 }) },
      { value: "3", label: "3 " + t("guest", { count: 3 }) },
      { value: "4", label: "4 " + t("guest", { count: 4 }) },
      { value: "5", label: "5 " + t("guest", { count: 5 }) },
      { value: "6", label: "6 " + t("guest", { count: 6 }) },
      { value: "7", label: "7 " + t("guest", { count: 7 }) },
      { value: "8", label: "8 " + t("guest", { count: 8 }) },
      { value: "9", label: "9 " + t("guest", { count: 9 }) },
      { value: "10", label: "10 " + t("guest", { count: 10 }) },
      { value: "11", label: "11 " + t("guest", { count: 11 }) },
      { value: "12", label: "12 " + t("guest", { count: 12 }) },
      { value: "13", label: "13 " + t("guest", { count: 13 }) },
      { value: "14", label: "14 " + t("guest", { count: 14 }) },
      { value: "15", label: "15 " + t("guest", { count: 15 }) },
      { value: "16", label: "16 " + t("guest", { count: 16 }) },
      { value: "17", label: "17 " + t("guest", { count: 17 }) },
      { value: "18", label: "18 " + t("guest", { count: 18 }) },
      { value: "19", label: "19 " + t("guest", { count: 19 }) },
      { value: "20", label: "20 " + t("guest", { count: 20 }) },
    ],
    [t]
  );

  return (
    <>
      <Container>
        <Input
          placeholder="Name"
          type="text"
          endAddorment="user"
          className="form-name"
          disabled={disabled}
          error={!!errors.name}
          errorMessage={errors.name?.message}
          {...register("name", {
            required: t("forms:validation.required").toString(),
          })}
        />
        <Input
          placeholder="E-Mail"
          type="email"
          endAddorment="at-sign"
          className="form-email"
          disabled={disabled}
          error={!!errors.email}
          errorMessage={errors.email?.message}
          {...register("email", {
            required: t("forms:validation.required").toString(),
            pattern: {
              value: /^.+?@.+?\..+?$/i,
              message: t("forms:validation.bad-format").toString(),
            },
          })}
        />

        <Input
          placeholder={t("Mobile")}
          type="tel"
          endAddorment="mobile"
          className="form-mobile"
          disabled={disabled}
          error={!!errors.mobile}
          errorMessage={errors.mobile?.message}
          {...register("mobile", {
            required: t("forms:validation.required").toString(),
            pattern: {
              value: /^\+?[0-9\s]+$/i,
              message: t("forms:validation.bad-format").toString(),
            },
          })}
        />

        <Input
          type="select"
          options={guestsOptions}
          className="form-guests"
          title="Guests"
          disabled={disabled}
          {...register("guests")}
        />
      </Container>

      <BookingDatePicker control={control} onGetCalendar={onGetCalendar} />
    </>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(15em, 1fr));
  gap: 0.5em;
`;
